/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Error1Inputs */

const he_notfound_error1 = /** @type {(inputs: Notfound_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שגיאה`)
};

const en_notfound_error1 = /** @type {(inputs: Notfound_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Notfound_Error1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const notfound_error1 = /** @type {((inputs?: Notfound_Error1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Error1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notfound_error1(inputs)
	return en_notfound_error1(inputs)
});
export { notfound_error1 as "notFound_error" }